import script from "./ListarPessoasFisicas.vue?vue&type=script&setup=true&lang=js"
export * from "./ListarPessoasFisicas.vue?vue&type=script&setup=true&lang=js"

import "./ListarPessoasFisicas.vue?vue&type=style&index=0&id=5e508933&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5e508933"]])

export default __exports__